import React, { useState, useRef } from "react";
import { Dropdown, Nav } from "react-bootstrap";
import Select from "react-select";
import useMessage from "hooks/useMessage";
import ToolTip from "components/ToolTip/ToolTip";
import useExceptionHandler from "hooks/useExceptionHandler";
import { GridView } from "components";
import { Simplebar } from "components/Simplebar/Simplebar";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useAuthentication } from "hooks";
import { DEFAULT_PAGINATION_VALUES } from "utils";
import { AuthenticationManager } from "managers";
import usePaginationValuesWhere from "hooks/usePaginationValuesWhere";
import IconButton from "components/IconButton/IconButton";
import { SvgComponent } from "components/SvgComponent/SvgComponent";
import { Compania } from "models/Compania";
import { CompaniaManager } from "managers";

export const SwitchCompanyButton = () => {
  const { cambiarCompania } = useAuthentication();
  const [showCanvas, setShowCanvas] = useState(false);

  const { Warning, cerrarAlertas } = useMessage();
  const { handleException } = useExceptionHandler();
  const [list, setList] = useState([]);
  const [where, setWhere] = useState({});
  const [pagination, setPagination] = useState({
    ...DEFAULT_PAGINATION_VALUES,
    OrderBy: "Id",
  });
  const { setPaginationValuesWhere } = usePaginationValuesWhere();
  const simplebarRef = useRef();
  const ESTATUS_LIST = [
    { value: "", label: "Todos" },
    ...Compania.ESTATUS_LIST,
  ];

  useEffect(() => {
    if (showCanvas) {
      buscar();
    }
    return () => {
      cerrarAlertas();
      hideLoading();
    };
  }, [where, showCanvas]);

  const showLoading = () => {
    try {
      simplebarRef?.current?.showLoading(true);
    } catch (error) {
      console.dev(error);
    }
  };

  const hideLoading = () => {
    try {
      simplebarRef?.current?.showLoading(false);
    } catch (error) {
      console.dev(error);
    }
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhere({ ...where });
  };

  const handleClick = (id) => {
    if (id) {
      showLoading();
      cambiarCompania({ Id: id })
        .then(() => {
          window.location.reload();
        })
        .catch((e) => {
          handleException(e);
        })
        .finally(() => {
          hideLoading();
        });
    } else {
      Warning({ message: "Compañía inválida." });
    }
  };

  const buscar = () => {
    const whereWithPaginationValues = { ...where, ...pagination };
    CompaniaManager.listado(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        setList(res.Data || []);
      })
      .catch((error) => {
        handleException(error);
      });
  };

  return (
    <>
      <Dropdown as={Nav.Item}>
        <Dropdown.Toggle
          as={Nav.Link}
          id="dropdown-company-switch"
          className="buttonHover"
          onClick={() => {
            setShowCanvas(true);
          }}
        >
          <ToolTip placement="left" message="Cambiar Compañía">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              width="24"
              viewBox="0 -960 960 960"
              fill="#77777A"
              fillRule="evenodd"
              clipRule="evenodd"
            >
              <path d="m368-232 43-43-84-84h193v-60H327l84-84-43-43-157 157 157 157Zm224-174 157-157-156-157-44 43 84 84H440v60h193l-84 84 43 43ZM480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-156t86-127Q252-817 325-848.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82-31.5 155T763-197.5q-54 54.5-127 86T480-80Zm0-60q142 0 241-99.5T820-480q0-142-99-241t-241-99q-141 0-240.5 99T140-480q0 141 99.5 240.5T480-140Zm0-340Z" />
            </svg>
          </ToolTip>
        </Dropdown.Toggle>
      </Dropdown>

      {createPortal(
        <Simplebar
          ref={simplebarRef}
          size="lg"
          useLoading={true}
          backdrop={true}
          placement={"end"}
          portal={false}
          visible={showCanvas}
          setShow={(e) => {
            setShowCanvas(e);
            cerrarAlertas();
          }}
          title={"Cambiar Compañía"}
          btnLeft={{
            show: false,
            func: () => { },
          }}
          btnRight={{
            show: false,
            func: () => { },
          }}
        >
          <>
            <GridView
              pagination={pagination}
              setPagination={setPagination}
              allowPaging={pagination.EsPaginable}
              pageSize={pagination.CantidadPorPagina}
              pageIndex={pagination.IndiceDePagina}
              lastPageNumber={pagination.PaginasTotal}
              dataSource={list}
              onPageIndexChanging={onPageIndexChanging}
              where={where}
              setWhere={setWhere}
              height="70vh"
            >
              <GridView.Column
                isSticky
                bodyRenderer={(row) => {
                  return (
                    <>
                      <div className="float-right">
                        <IconButton onClick={() => handleClick(row.Id)}>
                          <ToolTip message="Ingresar">
                            <div>
                              <SvgComponent
                                iconName="user"
                                height="25"
                                width="25"
                              />
                            </div>
                          </ToolTip>
                        </IconButton>
                      </div>
                    </>
                  );
                }}
              />

              {list && list.length >= 0 && (
                <GridView.Column
                  headerText="Id"
                  dataField="Id"
                  sortExpression="Id"
                  width="100px"
                />
              )}

              <GridView.Column
                headerText="Nombre"
                dataField="Nombre"
                sortExpression="Nombre"
              />
              <GridView.Column
                headerText="Código"
                dataField="Codigo"
                sortExpression="Codigo"
              />
              <GridView.Column
                headerText="Estatus"
                dataField="Estatus"
                sortExpression="Estatus"
                filterRenderer={(onFilterChange) => {
                  return (
                    <Select
                      className="react-select primary"
                      options={ESTATUS_LIST}
                      value={ESTATUS_LIST.filter(function (option) {
                        return (
                          option.value ===
                          (where.Estatus
                            ? where.Estatus
                            : ESTATUS_LIST[0].value)
                        );
                      })}
                      name="Estatus"
                      onChange={(e) =>
                        onFilterChange({
                          target: { name: "Estatus", value: e.value },
                        })
                      }
                    ></Select>
                  );
                }}
              />
            </GridView>
          </>
        </Simplebar>,
        document.querySelector("#sidebarContainer")
      )}
    </>
  );
};
